import Headroom from 'headroom.js';

function init() {
	// const list = document.querySelector('.js-catalog-section-list');
	// if (!list) return;
	//
	// console.log(list.offsetTop, list.offsetHeight);
	//
	// document.addEventListener('scroll', () => {
	//
	// })

	const trigger = document.querySelector('.js-sticky-section-list__trigger');
	const list = document.querySelector('.fixed-section-list');
	if (!trigger || !list) return;

	if (
		'IntersectionObserver' in window &&
		'IntersectionObserverEntry' in window &&
		'intersectionRatio' in window.IntersectionObserverEntry.prototype
	) {
		let observer = new IntersectionObserver((entries) => {
			if (entries[0].boundingClientRect.y < 0) {
				list.removeAttribute('hidden');
			} else {
				list.setAttribute('hidden', 'hidden')
			}
		});
		observer.observe(trigger);
	}
}

init();
